import {Component, OnInit} from '@angular/core';
import {IonicModule, ModalController} from '@ionic/angular';
import {NgIf} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {ArbameService} from '../../services/arbame.service';
import {CaptchaModule} from '../captcha/captcha.module';
import {locate} from 'ionicons/icons';
import {ToastService} from '../../services/toast.service';
import {SubService} from '../../services/sub.service';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss'],
  imports: [
    IonicModule,
    NgIf,
    FormsModule,
    CaptchaModule,
  ],
  standalone: true,
})
export class AuthComponent implements OnInit {
  stage = 'login';
  tradeCode: any;
  tradeCodeError: any;
  email: any;
  emailError: any;

  constructor(private aService: ArbameService, private modalCtrl: ModalController, private ts: ToastService, private sub: SubService) {
  }

  ngOnInit() {
  }

  loadingLogin;

  login() {
    let hasError;
    const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    if (!this.email || this.email.trim() === '') {
      this.emailError = 'Required';
      hasError = true;
    } else if (this.email.trim().length < 2) {
      this.emailError = 'Too short';
      hasError = true;
    } else if (!pattern.test(this.email) && this.email !== '') {
      this.emailError = 'Invalid Email';
      hasError = true;
    }

    if (!this.tradeCode || this.tradeCode.trim() === '') {
      this.tradeCodeError = 'Required';
      hasError = true;
    } else if (this.tradeCode.trim().length < 8) {
      this.tradeCodeError = 'Too short';
      hasError = true;
    }
    if (hasError) {
      return;
    }
    const fd = new FormData();
    fd.append('email', this.email);
    fd.append('password', this.tradeCode);
    // fd.append('key', this.captcha.key);
    // fd.append('captcha', this.captchaInput);
    this.loadingLogin = true;
    this.aService.login(fd).subscribe((data) => {
      this.loadingLogin = false;
      localStorage.setItem('token', data.data.token);
      this.sub.reloadBasket.next(true);
      this.ts.SuccessToast('Successfully logged in');
      this.modalCtrl.dismiss();
      this.sub.loadAppInit.next(true);
    }, error => {
      console.log(error);
      if (error.error.message.includes('captcha')) {
        this.ts.ErrorToast('Invalid Captcha Code');
      }
      if (error.error.message === 'invalid info' || error.error.message === 'The selected email is invalid.') {
        this.ts.ErrorToast('Invalid Login Info');
      }
      this.loadingLogin = false;
      this.recaptchaReload = true;
      setTimeout(() => {
        this.recaptchaReload = false;
      }, 400);
    });
  }

  captcha;
  recaptchaReload;

  CaptchaReceived($event) {
    this.captcha = $event;
  }

  registerCaptchaError;
  forgetCaptchaError;
  captchaInput;
  captchaError;

  captchaUserInputChanged($event: any) {

    this.captchaInput = $event;
    this.registerCaptchaError = null;
    this.forgetCaptchaError = null;
  }


  captchaForget;
  recaptchaReloadForget;

  CaptchaReceivedForget($event) {
    this.captcha = $event;
  }

  registerCaptchaErrorForget;
  forgetCaptchaErrorForget;
  captchaInputForget;
  captchaErrorForget;
  forgetEmail: any;
  forgetEmailError: any;

  captchaUserInputChangedForget($event: any) {

    this.captchaInputForget = $event;
    this.registerCaptchaErrorForget = null;
    this.forgetCaptchaErrorForget = null;
  }

  dimiss() {
    this.modalCtrl.dismiss();
  }

  loadingForget = false;

  sendForgetCode() {
    const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    if (!this.forgetEmail || this.forgetEmail.trim() === '') {
      this.forgetEmailError = 'Required';
      return;
    } else if (this.forgetEmail.trim().length < 2) {
      this.forgetEmailError = 'Too short';
      return;
    } else if (!pattern.test(this.forgetEmail) && this.forgetEmail !== '') {
      this.forgetEmailError = 'Invalid Email';
      return;
    }
    const fd = new FormData();
    fd.append('email', this.forgetEmail);
    this.loadingForget = true;
    this.aService.forgetCode(fd).subscribe((data) => {
      this.stage = 'send_forget';
      this.loadingForget = false;
    }, error => {

      this.ts.ErrorToast('Oops! something went wrong');
      this.loadingForget = false;
    });
  }

  openRegister() {
    this.dimiss();
    setTimeout(() => {
      this.sub.joinTrade.next(true);
    }, 300);
  }
}
